import type { ClientAnalysisReference } from "Infrastructure/ApiZfp/Schema";

export type SplitAnalyses = {
  readonly myAnalyses: ClientAnalysisReference[];
  readonly otherAnalyses: ClientAnalysisReference[];
};

/**
 * Splits the client's analyses into the two tabs.
 *
 * My own analyses are ordered by `version` (newest first) - it is a per-advisor sequence number.
 * Other advisors' analyses are ordered by `createdAt` instead, because their `version` counts within
 * each owning advisor and is therefore not comparable across advisors.
 *
 * `filter()` already returns a copy, so the following `sort()` never mutates the cached array.
 */
export const splitAnalysesByOwnership = (analyses: readonly ClientAnalysisReference[]): SplitAnalyses => ({
  myAnalyses: analyses.filter((analysis) => analysis.isOwner).sort((a, b) => b.version - a.version),
  otherAnalyses: analyses.filter((analysis) => !analysis.isOwner).sort((a, b) => b.createdAt.localeCompare(a.createdAt)),
});
